/// <reference path="../../app.definition.ts" />


function map() {
    return function (arr, mapParam, type) {
        if (Array.isArray(arr)) {
            if (type.toLowerCase() == "object") {
                return arr.map(function (s) {
                    const obj = {};
                    for (const key in mapParam) {
                        obj[key] = s[mapParam[key]];
                    }
                    return obj;
                });
            } else if (type.toLowerCase() == "value_array") {
                return arr.map(function (s) {
                    return s[mapParam];
                });
            }
        }
        return [];
    };
}
angular.module('eCareVault.common.filters').filter('map', map);

